export const COMMON_LIMIT = 20;
export const COMMUNITY_MEMBERS_LIMIT = 20;
export const LOTS_LIMIT = 24;
export const NOTIFICATIONS_LIMIT = 20;
export const CHATS_LIMIT = 20;
export const MESSAGES_LIMIT = 40;
export const OFFERS_LIMIT = 24;
export const CITIES_LIMIT = 8;
export const ITEMS_LIMIT_TO_SELECT_SHIPPING = 200;
